export default __webpack_public_path__ + "static/media/Mess-Less.c5f08a21.gif";